/**
 * 세로 화면 고정 시도
 * - PWA(홈 화면 추가)·Android Chrome 에서 잘 동작
 * - 일반 브라우저 탭·iOS Safari 는 OS가 막는 경우가 많음
 */
export async function lockPortraitOrientation(): Promise<void> {
  try {
    const orient = screen.orientation as ScreenOrientation & {
      lock?: (orientation: OrientationLockType) => Promise<void>
    }
    if (typeof orient?.lock === 'function') {
      await orient.lock('portrait')
    }
  } catch {
    /* 권한·환경 미지원 — 무시 */
  }
}

export function usePortraitLock() {
  const run = () => {
    void lockPortraitOrientation()
  }

  run()
  window.addEventListener('orientationchange', run)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') run()
  })
}
